import { YearComparison } from 'core/api/home/useApiGetLastFourWeeksStorePerformance'

type DeltaVariant = 'positive' | 'negative'

export type ComputedDelta = {
  formatted: string
  variant: DeltaVariant
}

export const computeDelta = (
  comparison: YearComparison,
  formatNumber: (value: number, fallback: string, options?: Intl.NumberFormatOptions) => string
): ComputedDelta => {
  const { current, previous } = comparison
  if (previous === 0) return { formatted: '', variant: 'positive' }
  const percentage = (current - previous) / previous
  return {
    formatted: formatNumber(percentage, '', {
      style: 'percent',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
      signDisplay: 'always'
    }),
    variant: percentage >= 0 ? 'positive' : 'negative'
  }
}
